module.exports = __webpack_public_path__ + "static/media/mini_logo.50e1eb46.png";